/* istanbul ignore file */

export const MODAL_TRASITION_MS = 250;
